<template>
	<div
		class="input-box"
		@click="$refs['textInput'].focus()"
		:class="{
			error: !isValid,
		}"
	>
		<input
			type="text"
			ref="textInput"
			@input="handleInput"
			@blur="blurDelete"
			:value="value"
		/>
		<span class="placeholder" :class="{ active: value }">{{
			tt(placeholder)
		}}</span>
		<span v-if="!isValid" class="noti">{{ validText }}</span>
		<button v-if="value.length > 0" @click="clickDelete">
			<img src="@/assets/svg/delete.svg" />
		</button>
	</div>
</template>

<script>
export default {
	name: 'ProgressInputAutoIncrement',
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		index: {
			type: Number,
			default: 0,
		},
		length: {
			type: Number,
			default: 0,
		},
		value: {
			type: String,
			default: '',
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		validText: {
			type: String,
			default: '',
		},
	},
	watch: {
		inputValue: {
			handler(value) {
				this.$emit('update', this.index, value)
			},
		},
	},
	data() {
		return {
			inputValue: '',
		}
	},
	methods: {
		handleInput(e) {
			this.$emit('input', e.target.value)
			this.inputValue = e.target.value
			if (this.index === 0 && this.inputValue === e.target.value) {
				this.$emit('update', this.index, e.target.value)
			}
		},
		clickDelete() {
			this.$emit('clickDelete', this.index)
		},
		blurDelete() {
			if (
				this.inputValue.length == 0 &&
				this.length > 0 &&
				this.length != this.index + 1
			) {
				this.$emit('clickDelete', this.index)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.input-box {
	width: 100%;
	position: relative;
	margin-bottom: 10px;
	&.error {
		input {
			border-color: #ff5746;
		}
		span {
			display: flex;
		}
	}
	input {
		width: 100%;
		height: 56px;
		border-radius: 8px;
		border: 1px solid #ddd;
		padding: 10px 14px 0 14px;
		font-size: 1rem;
	}
	input:focus {
		border-color: #000;
	}
	input:focus ~ .placeholder {
		font-size: 0.75rem;
		top: 5px;
	}
	.placeholder {
		position: absolute;
		font-size: 1rem;
		font-weight: 400;
		color: #999;
		display: block;
		top: 16px;
		left: 14px;
		transition: all 0.3s;
		background-color: unset !important;
		&.active {
			font-size: 0.75rem;
			top: 5px;
		}
	}
	.noti {
		font-size: 0.75rem;
		font-weight: 400;
		background-image: url(~@/assets/svg/icon-error_r.svg);
		background-repeat: no-repeat;
		background-position: top 2px left 0;
		padding-left: 16px;
		color: #ff5746;
		text-align: left;
		display: none;
		margin-top: 4px;
	}
	button {
		width: 18px;
		height: 18px;
		position: absolute;
		top: 18px;
		right: 18px;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
</style>
